import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import {AVAILABLE_VISUALIZERS} from "../../constants/dashboard";
import {VISUALIZER_TYPES_NAMES} from "../../constants/newScopeConstants";

class NewScopeAsideSubscriptionButtons extends Component {

  getSubscriptionButtonsArray() {
    return [{
      title: "Kitchen",
      buttonId: AVAILABLE_VISUALIZERS.kitchen
    }, {
      title: "Bathroom",
      buttonId: AVAILABLE_VISUALIZERS.bathroom
    }, {
      title: "Fireplace",
      buttonId: AVAILABLE_VISUALIZERS.fireplace
    }, {
      title: "Laundry Room",
      buttonId: AVAILABLE_VISUALIZERS.laundryroom
    }, {
      title: "Lead Form",
      buttonId: AVAILABLE_VISUALIZERS.leadform
    }]
  }

  render = () => {

    const {fabricatorSubscriptions, categoriesVisualizer, setCategoriesVisualizer} = this.props;

    return (
      <ul className="assign-sidebar-visualizer">
        {this.getSubscriptionButtonsArray().map(button => {
          const hasSubscr = fabricatorSubscriptions.some(sub => sub.service === button.buttonId);
          return (
            <li className="assign-sidebar-visualizer__button" key={button.buttonId}>
              <button className={"ui-button5" + (hasSubscr ? '' : ' ui-button5--disabled')
                + ((categoriesVisualizer === button.buttonId) && hasSubscr ? ' ui-button5--green' : ' ui-button5--gray')}
                      title={hasSubscr ? '' : button.title + ' subscription is not available'}
                      onClick={() => setCategoriesVisualizer(button.buttonId)}>
                {button.title}
              </button>
            </li>
          )
        })}
      </ul>
    )
  }
}

NewScopeAsideSubscriptionButtons.propTypes = {
  setCategoriesVisualizer: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {categoriesVisualizer, fabricatorSubscriptions} = store.newScope;

  return {
    categoriesVisualizer,
    fabricatorSubscriptions,
  };
};

export default connect(mapStateToProps)(NewScopeAsideSubscriptionButtons);
